import React from "react"
import { Layout } from "~/src/components"
import { CardsBlock, Header } from "planetyze-ui"
import { graphql } from "react-apollo"
import query from "./Blogs.gql"
import getContext from "context"

const Blogs = props => {
  const { t } = getContext()

  return (
    <Layout.Loader {...props.data}>
      {({ location, blogs }) => {
        const path = [
          { label: t("japan"), url: "/" },
          { label: location.title, url: location.url }
        ]

        const params = {
          location: location.title
        }

        return (
          <Layout
            title={t("seo.location-blogs.title", params)}
            description={t("seo.location-blogs.description", params)}
            pageType="city-blogs"
            url={props.uri}
            location={location.slug}>
            <div className="container">
              <Header title={t("blogs.title", params)} path={path} />
              <CardsBlock
                items={blogs.nodes}
                src={location.image ? location.image.url : null}
                theme="lg"
                pageInfo={blogs.pageInfo}
              />
            </div>
          </Layout>
        )
      }}
    </Layout.Loader>
  )
}

export default graphql(query, {
  options: props => {
    return {
      variables: {
        location: props.slug
      }
    }
  }
})(Blogs)
